import React from "react";
import FileUploadComplete from "./FileUploadComplete";

export default function FileUploadCompleteWarning({
    selectedFiles = () => [],
    setFileUploadState,
    fileUploadParameters,
    displayParameters,
    progress
}) {
    return (
        <div>
            <div className="alert margin-top" id='file-upload-error-alert'>
                <div className="alert--medium-importance">
                    <span className="icon-alert"></span>
                    <ul className="alert-list">
                        {displayParameters.submissionErrorAlertContent}
                    </ul>
                </div>
            </div>
            <FileUploadComplete
                selectedFiles={selectedFiles}
                setFileUploadState={setFileUploadState}
                fileUploadParameters={fileUploadParameters}
                displayParameters={displayParameters}
                progress={progress}
            />
        </div>
    );
};
